import styled from 'styled-components';
import { getColor } from '../../core/themev3';
import { select, withQuery } from '../../core/themev2';
import { NumericInput } from './numericInput';

export const FeatureLabel = styled.label`
  display: block;
  margin-bottom: 10px;
  ${withQuery.xs.down()} {
    margin-bottom: 0px;
    white-space: break-spaces;
    display: flex;
    align-items: center;
  }
`;

export const DropdownInput = styled(NumericInput)`
  border: 1px solid ${select('middleGray')};
  border-radius: 8px;
  width: auto;
  height: 40px;
  max-width: 166px;
  text-align: center;
  padding: 0px 0px 0px 66px;
  ${withQuery.xs.down()} {
    height: 54px;
    padding: 0px 0px 0px 166px;
    border-radius: 8px;
    max-width: 100%;
    min-width: 100%;
  }
  :focus {
    outline: none;
    border: 1px solid ${getColor('primary')};
  }
  :focus::placeholder {
    color: transparent;
    transition: 200ms;
  }
`;

export const Container = styled.div`
  position: relative;
  height: 66px;
  width: 128px;
  ${withQuery.xs.down()} {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: inherit;
    border-bottom: 1px solid ${select('middleGray')};
    height: auto;
    margin: 0px;
    &:last-child {
      margin: 0px;
    }
  }
  ${withQuery.xs.down()} {
    flex-direction: column;
  }
`;

export const OptionsContainer = styled.div`
  position: relative;
  ${withQuery.xs.down()} {
    display: inline-block;
  }
`;

export const Select = styled.select`
  width: 100%;
  max-width: 63px;
  height: 90%;
  background: ${select('lightGray')};
  border-radius: 8px 0 0px 8px;
  margin: 1px 0 0 1px;
  position: absolute;
  left: 1px;
  top: 1px;
  padding-left: 15px;
  cursor: pointer;
  -webkit-appearance: initial;
  :focus {
    outline: none;
  }
  :focus + input {
    border: 1px solid ${getColor('primary')};
  }
  ${withQuery.xs.down()} {
    max-width: 40%;
    width: 150px;
    height: 52px;
    top: 1px;
    left: 1px;
    text-align: center;
    padding-left: 44px;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    margin: 0px;
  }
`;

export const OneOptionView = styled.div`
  width: 100%;
  max-width: 63px;
  height: 90%;
  background: ${select('lightGray')};
  border-radius: 8px 0 0px 8px;
  margin: 1px 0 0 1px;
  position: absolute;
  left: 2px;
  top: 1px;
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  ${withQuery.xs.down()} {
    max-width: 40%;
    width: 150px;
    height: 52px;
    margin: 0px;
  }
`;
